var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@web/components/ui/Form/Select';
import { useUserContext } from '@web/contexts/User';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { NavigateTo } from '@web/router/NavigateTo';
import { filterUsersByOrgUnitAndRole } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useHasScope } from '@web/utility/hooks/useHasScope';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { CanAccess } from '@web/utility/wrapper/CanAccess';
import { ScopeUIFilterEnum } from '@workalizer/shared';
import { OrgUnitTypeEnum } from '@workalizer/shared/enums';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
export function OrgUnitsFilterSelect(_a) {
    var _b;
    var _c = _a.isVisible, isVisible = _c === void 0 ? true : _c, _d = _a.showAllOption, showAllOption = _d === void 0 ? true : _d, _e = _a.isOpenByDefault, isOpenByDefault = _e === void 0 ? false : _e, _f = _a.resetUserOnAll, resetUserOnAll = _f === void 0 ? false : _f, _g = _a.autoSelectFirstUser, autoSelectFirstUser = _g === void 0 ? false : _g, userRole = _a.userRole, _h = _a.hideAllWhenUserSelected, hideAllWhenUserSelected = _h === void 0 ? false : _h;
    var _j = useWorkspaceCtx(), orgUnits = _j.orgUnits, users = _j.users;
    var currentUser = useUserContext().currentUser;
    var filters = useFilters();
    var hasScopeOrgUnitFilter = useHasScope(ScopeUIFilterEnum.FILTER_ORG_UNIT);
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var t = useTranslation().t;
    var canShowAll = showAllOption && (!hideAllWhenUserSelected || !filters.user);
    var filteredOrgUnits = userRole
        ? orgUnits.filter(function (orgUnit) {
            return users.some(function (user) { var _a; return ((_a = user.orgUnit) === null || _a === void 0 ? void 0 : _a.id) === orgUnit.id && user.role === userRole; });
        })
        : orgUnits;
    var sortedOrgUnits = __spreadArray([], filteredOrgUnits, true).sort(function (a, b) {
        var aIsDefault = a.type === OrgUnitTypeEnum.DEFAULT;
        var bIsDefault = b.type === OrgUnitTypeEnum.DEFAULT;
        if (aIsDefault !== bIsDefault)
            return aIsDefault ? 1 : -1;
        return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' });
    });
    var orgUnitOptions = __spreadArray(__spreadArray([], (canShowAll && hasScopeOrgUnitFilter
        ? [
            {
                id: null,
                name: t('filters.allTeams'),
                isAll: true
            }
        ]
        : []), true), sortedOrgUnits.map(function (orgUnit) { return ({
        id: orgUnit.id,
        name: orgUnit.title,
        disabled: !users.some(function (user) { var _a; return ((_a = user.orgUnit) === null || _a === void 0 ? void 0 : _a.id) === orgUnit.id; }),
        withDivider: orgUnit.type === OrgUnitTypeEnum.DEFAULT
    }); }), true);
    var selectedOrgUnit = orgUnitOptions.find(function (orgUnit) { return orgUnit.id === filters.orgUnit; }) ||
        orgUnitOptions[0] ||
        null;
    function onChange(newOption) {
        var newFilters = {
            orgUnit: newOption.id
        };
        if (resetUserOnAll && !newOption.id && filters.user) {
            newFilters.user = null;
        }
        if (autoSelectFirstUser && newOption.id) {
            var filteredUsers = filterUsersByOrgUnitAndRole(users, newOption.id, userRole);
            var firstUser = filteredUsers[0];
            var orgUnitChanged = filters.orgUnit !== newOption.id;
            var shouldSelectFirstUser = firstUser && (!filters.user || orgUnitChanged);
            if (shouldSelectFirstUser) {
                newFilters.user = firstUser.id;
            }
        }
        navigateTo({
            pathname: location.pathname,
            newFilters: newFilters
        });
    }
    if (!hasScopeOrgUnitFilter && ((_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.orgUnit) === null || _b === void 0 ? void 0 : _b.id) !== filters.orgUnit) {
        var currentOrgUnitOption = orgUnitOptions.find(function (orgUnit) { var _a; return orgUnit.id === ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.orgUnit) === null || _a === void 0 ? void 0 : _a.id); });
        if (currentOrgUnitOption) {
            return (_jsx(NavigateTo, { pathname: location.pathname, newFilters: { orgUnit: currentOrgUnitOption.id } }));
        }
        return null;
    }
    return isVisible ? (_jsx(CanAccess, __assign({ scope: ScopeUIFilterEnum.FILTER_ORG_UNIT }, { children: _jsx("div", __assign({ className: "w-full sm:max-w-72" }, { children: _jsx(Select, { label: t('filters.orgUnit'), selected: selectedOrgUnit, options: orgUnitOptions, onChange: onChange, withSearchField: true, valueClassName: (selectedOrgUnit === null || selectedOrgUnit === void 0 ? void 0 : selectedOrgUnit.id) ? undefined : 'text-gray-500', isOpenByDefault: isOpenByDefault }) })) }))) : null;
}
export default OrgUnitsFilterSelect;
